// import fetch from '../utils/fetch';
import fetch,{ postFrom } from '../utils/fetch';

// 功能区列表查询
export function getList(params) {
    return fetch({
        method: 'GET',
        url: 'functionalarea/list',
        params
    })
}
// 项目下的功能区
export function getFnByProject(params) {
    return fetch({
        method: 'GET',
        url: 'functionalarea/allByProject',
        params
    })
}

// 房间号模糊查询
export function fuzzyRoom(params) {
    return fetch({
        method: 'GET',
        url: 'projectBasics/fuzzyroom',
        params
    })
}

// 项目联动数据查询

export function getBuildInfo() {
    return fetch({
        method: 'GET',
        url: 'projectBasics/buildInfo'
    })
}

// 添加功能区
export function addFunctionalarea(data) {
    return postFrom('/functionalarea/add', data);
}

// 删除功能区
export function deleteFunctionalarea(data) {
    return postFrom('/functionalarea/delete', data);
}

// 修改功能区
export function updateFunctionalarea(data) {
    return postFrom('/functionalarea/update', data);
}



